import lang from 'core/providers/LangProvider/slice';
import auth from 'core/providers/AuthProvider/slice';

const coreReducer = {
  lang,
  auth,
};

export default coreReducer;
